import React, { useState } from'react';
import styled from '@emotion/styled';
import ReactPixel from 'react-facebook-pixel';

interface HeaderPcProps {
  disable: boolean;
}
const HeaderPc:React.FC<HeaderPcProps> = ({ disable }) => {
  const handleGotoHomapage:React.MouseEventHandler<HTMLDivElement> | undefined = () => {
    window.location.href="/"
  };

  const handleGotoSubscribe = () => {
    window.location.href="/plan"
  };

  const handleGotoApp = () => {
    window.location.href="/print"
  };

  const handleGotoProduct = () => {
    window.location.href="/product"
  };

  const handleGotoEvent = () => {
    window.location.href="event"
  };

  const handleGotoPlan = () => {
    //   ReactPixel.fbq('trackCustom', 'planTap', {
    //   "content_name": 'Paln Tap',
    //   "content_category": 'Mobile App',
    //   // "fbc": fbc,
    //   "store": 'appStore',
    //   "city": "KR",
    //   "gender" : "female"
    // })

    // window.location.href="plan"

    setTimeout(() => {
      window.location.href = "plan";
    }, 300);
  };


  return(
    <>
      <Header>
      <EvnetContainer
        // onClick={handleGotoEvent}
      >
        [마감 임박] 12개월 구독권 20% 할인 (~12. 20)
        </EvnetContainer>
        <MainContainer>
          <LogoImg onClick={handleGotoHomapage}>
            <ImgBox  src="/images/klikkie/main/logo.png"/>
          </LogoImg>
          <TapContainer>
            {/* <LinkTap
            onClick={handleGotoSubscribe}
            >인화구독</LinkTap>
            <span style={{height: "100%"}}>|</span> */}
            <LinkTap
            onClick={handleGotoPlan}
            >플랜</LinkTap>
            <span style={{height: "100%"}}>|</span>
            <LinkTap
            onClick={handleGotoProduct}
            >앨범</LinkTap>
            <span style={{height: "100%"}}>|</span>
            <LinkTap
            onClick={handleGotoApp}
            >인화</LinkTap>
            {/* <span style={{height: "100%"}}>|</span> */}
            {/* <LinkTap
            onClick={handleGotoEvent}
            >이벤트</LinkTap> */}
          </TapContainer>
        </MainContainer>
      </Header>
    </>
  )
};

export default HeaderPc;

const Header = styled.div`
  width: 100%;
  /* background-color: #ede3cd; */
  background-color: white;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 2;
  /* padding: 0px 5px; */
`;
const MainContainer = styled.div`
  width: 100%;
  height: 120px;
  /* height: 110px; */
  display: flex;
  flex-direction: row;
  align-items: end;
`

const EvnetContainer = styled.div`
  width: 100%;
  height: 40px;
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 13px;
  font-weight: 600;
  font-family: 'Pretendard', sans-serif;
`

const LogoImg = styled.div`
  width: 80px;
  height: 80px;
  margin: 20px 0 20px 10px;
`;

const TapContainer = styled.div`
  /* width: 40%; */
  width: 50%;
  height: 20px;
  /* background-color: yellow; */
  margin: 20px 40px 30px 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
`;

const LinkTap = styled.a`
  font-size: 15px;
  color: #707070;
  &:hover{
    color: #ccc;
  }
`;

const ImgBox = styled.img`
  width: 100%;
  height: 100%;
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`